import { useState } from 'react';

const JOB_TEMPLATES = {
    fit_template: {
        operation: "job_param",
        payload: {
            job_type: "fit",
            run_tag: "test_run_v1",
            df_path: "df.csv",
            future_df_path: "future_df.csv",
            saturation_df_path: "saturation_df.csv",
            kpi_col: "sales",
            date_col: "date",
            resource_cols: ["promo", "radio", "search", "social", "tv"],
            event_cols: [
                "new-years-day",
                "martin-luther-king-jr-day",
                "washingtons-birthday",
                "memorial-day",
                "independence-day",
                "labor-day",
                "columbus-day",
                "veterans-day",
                "thanksgiving-day",
                "christmas-day",
                "independence-day-observed",
                "juneteenth-national-independence-day-observed",
                "juneteenth-national-independence-day",
                "christmas-day-observed",
                "new-years-day-observed"
            ],
            fit_args: {
                num_warmup: 250,
                num_samples: 125,
                num_chains: 8
            },
        }
    },
    attr_template: {
        operation: "job_param",
        payload: {
            job_type: "attribute",
            model_id: "<paste model id here>",
            run_tag: "test_run_v1"
        }
    },
    target_max_template: {
        operation: "job_param",
        payload: {
            job_type: "target_max",
            model_id: "<paste model id here>",
            run_tag: "test_run_v1",
            budget_start_date: "2024-03-11",
            budget_end_date: "2024-04-10",
            variants: [
                { lb: 1.0, ub: 1.0 },
                { lb: 1.0, ub: 1.1 },
                { lb: 1.0, ub: 1.2 },
            ]
        }
    }
};

export const useJobParameters = () => {
    const [selectedTemplate, setSelectedTemplate] = useState('fit_template');
    const [jobParam, setJobParam] = useState(() =>
        JSON.stringify(JOB_TEMPLATES['fit_template'], null, 2)
    );

    const handleTemplateChange = (event) => {
        const selected = event.target.value;
        setSelectedTemplate(selected);
        setJobParam(JSON.stringify(JOB_TEMPLATES[selected], null, 2));
    };

    const beautifyJobParam = () => {
        try {
            const beautified = JSON.stringify(JSON.parse(jobParam), null, 2);
            setJobParam(beautified);
        } catch (err) {
            alert("Invalid JSON format!");
        }
    };

    /**
     * Submit a job with optional parameter override
     * @param {Function} callApi - API call function to submit the job
     * @param {string|Object|null} overrideJobParam - Optional parameter to override the default jobParam
     *   - If null: uses the current jobParam state
     *   - If string: uses the provided JSON string
     *   - If object: converts the object to a JSON string
     * @returns {Promise} Response from the job submission
     */
    const submitJob = async (callApi, overrideJobParam = null) => {
        const jobParamToSubmit = overrideJobParam
            ? (typeof overrideJobParam === 'string' ? overrideJobParam : JSON.stringify(overrideJobParam, null, 2))
            : jobParam;

        if (!jobParamToSubmit) {
            alert("Blank job param!");
            return;
        }

        const confirmed = window.confirm(`Submit this job?\n\n${jobParamToSubmit}`);
        if (!confirmed) {
            // Return a special object to indicate user cancellation
            return { cancelled: true };
        }

        try {
            const responseBody = await callApi({
                path: '/ts-service-main',
                method: 'POST',
                body: JSON.parse(jobParamToSubmit),
                contentType: 'application/json',
            });
            alert(`Job submission response:\n\n${responseBody.message}`);
            return responseBody;
        } catch (err) {
            console.error('Job submission error:', err);
            alert(`Job submission failed.\n\n${err.message}\n\nCheck console for further details.`);
            throw err;
        }
    };

    return {
        selectedTemplate,
        jobParam,
        setJobParam,
        handleTemplateChange,
        beautifyJobParam,
        submitJob
    };
};
